var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-row", [
    _c("div", { staticClass: "controlls" }, [
      _vm._v(" " + _vm._s(_vm.$ct("if-value-between")) + " "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c("w-input-number", {
            attrs: { disabled: _vm.disabled },
            model: {
              value: _vm.value.LowerValue,
              callback: function ($$v) {
                _vm.$set(_vm.value, "LowerValue", $$v)
              },
              expression: "value.LowerValue",
            },
          }),
        ],
        1
      ),
      _vm._v(" " + _vm._s(_vm.$t("common.and")) + " "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c("w-input-number", {
            attrs: { disabled: _vm.disabled },
            model: {
              value: _vm.value.UpperValue,
              callback: function ($$v) {
                _vm.$set(_vm.value, "UpperValue", $$v)
              },
              expression: "value.UpperValue",
            },
          }),
        ],
        1
      ),
      _vm._v(" " + _vm._s(_vm.$ct("calculate-with-profit")) + " "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c("w-input-number", {
            attrs: { disabled: _vm.disabled },
            model: {
              value: _vm.value.ProfitPercentage,
              callback: function ($$v) {
                _vm.$set(_vm.value, "ProfitPercentage", $$v)
              },
              expression: "value.ProfitPercentage",
            },
          }),
        ],
        1
      ),
      _vm._v(" " + _vm._s(_vm.$ct("profit")) + " "),
    ]),
    _c(
      "div",
      [
        _c(
          "w-button",
          {
            attrs: { flat: "", disabled: _vm.deleteDisabled },
            on: {
              click: function ($event) {
                return _vm.onDelete()
              },
            },
          },
          [_c("w-fa", { attrs: { icon: "trash" } })],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }